import * as React from 'react';
import { Fragment } from 'react';
import { compose, setDisplayName, withHandlers } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { FadeCollapse } from 'ui/transitions/FadeCollapse';
import { EmailDistribution } from 'ui/pages/designer/sections/distribution/EmailDistribution';
import { FileDistribution } from 'ui/pages/designer/sections/distribution/FileDistribution';
import { ReportId, ReportType } from 'types';

export type OwnProps = {
    reportId: ReportId;
    reportType: ReportType;
    reportName: string;
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

const relativeStyle: React.CSSProperties = {
    position: 'relative',
};

type Props = OwnProps & RecomposeProps & TranslateProps;
const RawDistributionSection = ({ reportId, reportType, reportName, reportSettings, onChange, handleChangeEmailEnabled, handleChangeFileEnabled, t }: Props) => {
    let isCSVFileEnabled = false;
    let isCSVEmailEnabled = false;
    if (reportSettings.saveFileTypes[0] === 'CSV' || reportSettings.saveFileTypes[1] === 'CSV' ||
        reportSettings.saveFileTypes[2] === 'CSV' || reportSettings.saveFileTypes[3] === 'CSV') {
        isCSVFileEnabled = true;
    }
    if (reportSettings.emailFileTypes[0] === 'CSV' || reportSettings.emailFileTypes[1] === 'CSV' ||
        reportSettings.emailFileTypes[2] === 'CSV' || reportSettings.emailFileTypes[3] === 'CSV') {
        isCSVEmailEnabled = true;
    }

    const fileDistributionHeight =
        reportSettings.fileDistributionEnabled
            ? !reportSettings.useDefaultFileName
                ? isCSVFileEnabled
                    ? '29.5em'
                    : '24.5em'
                : isCSVFileEnabled
                    ? '24.5em'
                    : '20.5em'
            : '20em'; // or some default if needed
    const emailDistributionHeight = ( isCSVEmailEnabled ) ? '20.5em' : '14.5em';
    return (
        <Fragment>
            <div>
                <label>
                    <input
                        type="checkbox"
                        id="send-report-email"
                        checked={ reportSettings.emailDistributionEnabled }
                        onChange={ handleChangeEmailEnabled }
                    />
                    { t('WC_SEND_REPORT_EMAIL') }
                </label>
            </div>
            <FadeCollapse
                visible={ reportSettings.emailDistributionEnabled }
                duration={ 200 }
                height={ emailDistributionHeight }
            >
                <EmailDistribution
                    reportType={ reportType }
                    reportSettings={ reportSettings }
                    onChange={ onChange }
                />
            </FadeCollapse>
            <div style={ relativeStyle }>
                <label style={ relativeStyle }>
                    <input
                        type="checkbox"
                        id="save-report-file"
                        checked={ reportSettings.fileDistributionEnabled }
                        onChange={ handleChangeFileEnabled }
                    />
                    { t('WC_SAVE_REPORT_FILE') }
                </label>
            </div>
            <FadeCollapse
                visible={ reportSettings.fileDistributionEnabled }
                duration={ 200 }
                height={ fileDistributionHeight }
            >
                <FileDistribution
                    reportId={ reportId }
                    reportType={ reportType }
                    reportName={ reportName }
                    reportSettings={ reportSettings }
                    onChange={ onChange }
                />
            </FadeCollapse>
        </Fragment>
    );
};

type RecomposeProps = {
    handleChangeEmailEnabled: React.ChangeEventHandler<HTMLInputElement>;
    handleChangeFileEnabled: React.ChangeEventHandler<HTMLInputElement>;
};

export const DistributionSection = compose<Props, OwnProps>(
    setDisplayName('DistributionSection'),
    translate(),
    withHandlers<OwnProps, RecomposeProps>({
        handleChangeEmailEnabled: ({ onChange }) => (e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(reportSettings => reportSettings.setEmailDistributionEnabled(e.target.checked));
        },
        handleChangeFileEnabled: ({ onChange }) => (e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(reportSettings => reportSettings.setFileDistributionEnabled(e.target.checked));
        },
    })
)(RawDistributionSection);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/distribution/DistributionSection.tsx